import type { ErrorMessage } from 'root/apps/PurchaseOrder/ShipmentHistory/contexts/ErrorMessage';

export const ApiErrors = {
  GENERIC: {
    title: 'Something went wrong',
    message: 'Try again or contact support if the problem persists.',
  },
  GENERIC_GET: {
    title: 'Unable to load shipment information',
    message: 'Try again or contact support if the problem persists.',
  },
  GENERIC_PATCH: {
    title: "Shipment didn't update",
    message: 'Try again or contact support if the problem persists.',
  },
  SHIPMENT_PACKING_REF_NUM_EXCEED_MAX_LENGTH: {
    message: 'Shipping packing reference number must be shorter than 255 characters',
  },
  SHIPPING_COST_IS_NEGATIVE: { message: 'Shipping cost must be a positive number' },
  SHIPPING_VENDOR_COST_IS_NEGATIVE: { message: "Vendor's shipping cost must be a positive number" },
  PAYMENT_DUE_DATE_IS_INVALID: { message: 'Invoice due date is invalid. Try again.' },
  RECEPTION_DATE_IS_INVALID: { message: 'Reception date is invalid. Try again.' },
};

const errorCodeMap: { [key: number]: ErrorMessage } = {
  101: ApiErrors.SHIPMENT_PACKING_REF_NUM_EXCEED_MAX_LENGTH,
  102: ApiErrors.SHIPPING_COST_IS_NEGATIVE,
  103: ApiErrors.SHIPPING_VENDOR_COST_IS_NEGATIVE,
  104: ApiErrors.PAYMENT_DUE_DATE_IS_INVALID,
  105: ApiErrors.RECEPTION_DATE_IS_INVALID,
};

export const getApiError = (
  errorCode: number | 'GENERIC' | 'GENERIC_GET' | 'GENERIC_PATCH',
  method?: 'GET' | 'PATCH'
): ErrorMessage => {
  if (typeof errorCode === 'number' && errorCodeMap[errorCode]) {
    return errorCodeMap[errorCode];
  }
  if (method === 'GET') {
    return ApiErrors.GENERIC_GET;
  }
  if (method === 'PATCH') {
    return ApiErrors.GENERIC_PATCH;
  }
  return ApiErrors.GENERIC;
};
